import { useContext } from 'react';
import styled from 'styled-components';
import { TablePagination, TableRow, TableCell } from '@mui/material';
import { TableContext } from '../index';
import { useTranslation } from 'react-i18next';

const STablePagination = styled(TablePagination)`
  .MuiTablePagination-selectLabel,
  .MuiTablePagination-displayedRows {
    margin-bottom: 0;
  }
`;

export const Pagination = () => {
  const {
    paginationInfo,
    pageNumber,
    setPageNumber,
    rowsPerPage,
    setRowsPerPage,
  } = useContext(TableContext);

  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageNumber(0);
  };
  const { t } = useTranslation();
  return paginationInfo ? (
    <TableRow>
      <TableCell
        align="center"
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
        }}
      >
        {t('Total users') + ':'} {paginationInfo?.totalItems || 0}
      </TableCell>
      <STablePagination
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        count={paginationInfo?.totalItems}
        component="td"
        page={pageNumber}
        labelDisplayedRows={({ from, to, count }) => {
          return `${from}–${to} ${t('of')} ${
            count !== -1 ? count : `${'more than'} ${to}`
          }`;
        }}
        labelRowsPerPage={t('Rows per page') + ':'}
      />
    </TableRow>
  ) : null;
};
